export default "__VITE_ASSET__Czw7tvHb__"